import Reveal from '@/components/base/Reveal';

const steps = [
  {
    icon: 'ri-user-add-line',
    title: '회원가입',
    desc: '휴대폰 번호 인증만으로 간편하게 가입하세요.',
    tone: 'text-primary-400',
  },
  {
    icon: 'ri-search-eye-line',
    title: '상품 탐색',
    desc: '카테고리와 검색으로 원하는 상품을 찾아보세요.',
    tone: 'text-accent-400',
  },
  {
    icon: 'ri-shopping-bag-3-line',
    title: '구매 & 다운로드',
    desc: '결제 후 바로 파일을 다운로드 받으세요.',
    tone: 'text-secondary-300',
  },
  {
    icon: 'ri-store-2-line',
    title: '판매하기',
    desc: '판매자 등록 후 나만의 상품을 등록해 수익을 창출하세요.',
    tone: 'text-primary-400',
  },
];

export default function HowItWorks() {
  return (
    <section id="how" className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-24">
      <Reveal>
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-mono uppercase tracking-[0.25em] text-primary-500 whitespace-nowrap">
            how it works
          </span>
          <h2 className="mt-3 font-display text-3xl md:text-4xl font-normal tracking-tight text-white">
            누구나 쉽게 시작할 수 있어요
          </h2>
          <p className="mt-4 text-foreground-400">
            구매부터 판매까지, 단 네 단계로 충분합니다.
          </p>
        </div>
      </Reveal>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
        {steps.map((step, index) => (
          <Reveal key={step.title} delay={index * 80}>
            <div className="relative h-full rounded-2xl glass-card border border-white/8 p-6">
              <span className="absolute top-5 right-5 font-display text-4xl font-semibold text-background-500">
                0{index + 1}
              </span>
              <span className="w-12 h-12 flex items-center justify-center rounded-xl bg-white/5">
                <i className={`${step.icon} text-2xl ${step.tone}`}></i>
              </span>
              <h3 className="mt-4 font-heading font-semibold text-lg text-white">{step.title}</h3>
              <p className="mt-2 text-sm text-foreground-400 leading-relaxed">{step.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}